import { Translate } from "../translate"
import {
  DialogClose,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./dialog"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/
type I18nDialogHeaderProps = {
  i18nTitle: string
  titleClassName?: string
}
/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/
const I18nDialogHeader = ({
  i18nTitle,
  titleClassName,
}: I18nDialogHeaderProps) => {
  return (
    <DialogHeader>
      <DialogTitle className={titleClassName}>
        <Translate i18nKey={i18nTitle} />
      </DialogTitle>
      <DialogDescription />
      <DialogClose />
    </DialogHeader>
  )
}

export { I18nDialogHeader }
